import { render, staticRenderFns } from "./order-menu.vue?vue&type=template&id=61a6d604&scoped=true&lang=pug&"
import script from "./order-menu.vue?vue&type=script&lang=js&"
export * from "./order-menu.vue?vue&type=script&lang=js&"
import style0 from "./order-menu.vue?vue&type=style&index=0&id=61a6d604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a6d604",
  null
  
)

export default component.exports